// source: https://github.com/ziggi/dom-parents
// https://github.com/ziggi/dom-parents/blob/5ecacd64bd5fd4a02a467aaa68978b255fc2a795/LICENSE
export const getDOMParents = (element, selector, includeElement = false) => {
    const isWithSelector = selector !== undefined;
    const elements = [];
    let elem = element;

    if (!includeElement) {
        elem = elem.parentElement;
    }

    while (elem !== null) {
        if (elem.nodeType === Node.ELEMENT_NODE) {
            if (!isWithSelector || elem.matches(selector)) {
                elements.push(elem);
            }
        }

        elem = elem.parentElement;
    }

    return elements;
};
